import { Configuration, FrontendApi } from "@ory/client-fetch";

/**
 * OryClientConfig configures the Ory FrontendApi. sdkUrl is the public Ory
 * endpoint that serves the browser self-service flows (login, registration,
 * recovery, verification) — locally http://localhost:3001.
 */
export interface OryClientConfig {
  sdkUrl: string;
}

/**
 * createOryClient builds a FrontendApi bound to the given Ory SDK URL.
 * credentials: "include" attaches the ory_session_* cookie on every request,
 * which is required for browser-based self-service flows and toSession/whoami.
 *
 * Accept: application/json is forced on every SDK request because Ory's browser
 * self-service endpoints content-negotiate: with an explicit JSON Accept they
 * return the flow as JSON (the SPA path), but for the fetch default (a wildcard
 * Accept), text/html, or no Accept header they 303 to the UI URL — which an XHR
 * cannot follow. Without this header createBrowser*Flow over fetch bounces. The
 * direct browser-endpoint navigations (re-auth, logout) are real navigations, so
 * they keep getting the 303 and are unaffected.
 *
 * This is a render-free factory; the app builds one singleton from the runtime
 * env and threads it through the engine and the session bootstrap.
 */
export const createOryClient = (config: OryClientConfig): FrontendApi =>
  new FrontendApi(
    new Configuration({
      basePath: config.sdkUrl,
      credentials: "include",
      headers: { Accept: "application/json" },
    }),
  );
